import React from "react";
import {
  ToggleSwitch,
  ToggleTitleWrapper,
} from "../../../styled/ToggleTile.styled";

const ToggleButtonsComponent = ({ filters, onChange }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      {filters?.map((item) => {
        return (
          <div style={{ display: "flex", width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "50%",
              }}
            >
              <ToggleTitleWrapper main>{item?.filterName}</ToggleTitleWrapper>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "50%",
              }}
            >
              <ToggleSwitch
                checked={item.isChecked}
                onChange={() => onChange(item)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ToggleButtonsComponent;
